import { gql } from '@apollo/client';

export default gql`
  query inspectionSubject($id: ID!) {
    space {
      overInspectionsLimit
      adminRole
    }
    inspectionSubject(id: $id) {
      id
      name
      serialNumber
      inspectionsTotal
      incomingInspectionsTotal
      overdueInspectionsTotal
      place {
        id
        name
        street
        city
        zipCode
      }
      externalFiles {
        id
        filename
        contentType
        fileSize
        externalUrl
        isImage
        isPdf
        fileExtension
      }
    }
  }
`;
